import { render, staticRenderFns } from "./ProformaList.vue?vue&type=template&id=635f54a1&"
import script from "./ProformaList.vue?vue&type=script&lang=js&"
export * from "./ProformaList.vue?vue&type=script&lang=js&"
import style0 from "./ProformaList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports